module.exports = __webpack_public_path__ + "img/avatar.a48f7e75.png";